<template lang="pug">
  .form-group(:class='{"has-error": invalid}')
    label.form-label(v-if="label") {{ label }}
      span.text-error.required.tooltip.tooltip-right(v-if="(validation && validation[field].$params.required && validation[field].$params.required.type !== 'requiredIf')" data-tooltip='Obrigatório')
        | &nbsp;*
      slot(name="label-action")
      .float-right(v-if="help")
        .popover.popover-left
          a.c-hand.text-bold ?
          .popover-container
            .card
              .card-body {{ help }}
      .p-relative.pt-1
        slot
    .p-relative.pt-1(v-else)
      slot
    form-group-error(:validation="validation[field]" :model-errors="modelErrors" v-if="invalid")
</template>

<script>
import FormGroupError from './FormGroupError'
export default {
  props: {
    validation: Object,
    label: String,
    apiError: Object,
    field: String,
    help: String,
  },

  components: { FormGroupError },

  computed: {
    invalid() {
      if (!this.validation || !this.validation[this.field]) return false
      return (
        (this.validation[this.field].$invalid &&
          this.validation[this.field].$dirty) ||
        this.modelErrors
      )
    },

    modelErrors() {
      if (!this.apiError || this.apiError.code !== 'modelValidation')
        return null
      const error = this.apiError.constraints.find(
        i => i.property === this.field,
      )
      return error ? error.messages : null
    },
  },
}
</script>

<style lang="stylus" scoped>
a
  text-decoration none
</style>
